import { render, staticRenderFns } from "./add-import.vue?vue&type=template&id=90b95726&scoped=true&"
import script from "./add-import.vue?vue&type=script&lang=js&"
export * from "./add-import.vue?vue&type=script&lang=js&"
import style0 from "./add-import.vue?vue&type=style&index=0&id=90b95726&prod&lang=css&"
import style1 from "./add-import.vue?vue&type=style&index=1&id=90b95726&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b95726",
  null
  
)

export default component.exports